import { GCP_FUNCTION_URL } from "@app/scripts/config"

export const createContact = async (data: { [key: string]: unknown }) => {
  try {
    const response = await fetch(GCP_FUNCTION_URL + "/emarsysCreateContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      console.error("API call failed:", response.status, response.statusText)
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result = await response.json()
    console.debug("API call successful:", result)
    return result
  } catch (error) {
    console.error("Error creating contact:", error)
    throw error
  }
}

export const getSubscribedStatus = async (email: string) => {
  try {
    const response = await fetch(
      GCP_FUNCTION_URL + "/emarsysGetSubscribedStatus",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    )

    if (!response.ok) {
      console.error("API call failed:", response.status, response.statusText)
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result = await response.json()
    console.debug("API call successful:", result)
    return result
  } catch (error) {
    console.error("Error creating contact:", error)
    throw error
  }
}
